module.exports = __webpack_public_path__ + "static/media/icon.84773a74.svg";